import React from 'react';
import { connect } from 'react-redux';
import { translate, getUserNameToName, formatData } from '../../../utils/util';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { Row, Modal, Button } from 'react-materialize';
import ButtonUI from '../../../components/UI/ButtonUI';
import JustificationService from '../../../services/JustificationService';

const JustificationListItem = (props) => {
    const onConfirm = (justification) => {
        props.justificationDelete(justification, () => {
            props.history.go(-1);
        });
    };

    return (
        <>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', marginTop: '25px', right: '15px', zIndex: '999' }}
            >
                <Modal
                    id={`modal-id-${props.data.justificationId}`}
                    fixedFooter
                    style={{ marginTop: "15px", maxHeight: "60%" }}
                    actions={
                        <Row className="center" style={{ height: "60%" }}>
                            <Button className="col s6 btn waves-effect waves-light btn-flat" modal="close">
                                {translate('cancel', 'general')}
                            </Button>
                            <ButtonUI onClick={() => onConfirm(props.data)} text={translate('delete', 'general')} />
                        </Row>
                    }
                    trigger={
                        <i className="material-icons small sixth-text-color" style={{ cursor: 'pointer' }}>delete</i>
                    }>
                    <div>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="col s12">
                                    <i className="material-icons large">info_outline</i>
                                </span>
                                <span className="title col s12">{translate('messages.confirmation-delete', 'justification')}</span>
                                {/* <span className="col s12" >{translate('fields.code', 'justification')}: {`${props.data.code}`}</span> */}
                                <span className="col s12">{translate('fields.description', 'justification')}: {`${props.data.description}`}</span>
                            </div>
                        </Row>
                    </div>
                </Modal>
            </span>
            <Link
                style={{ display: 'block' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                {/* <span className="title sixth-text-color col s12">
                    {`${props.data.code}`}
                </span> */}
                <span className="second-text-color" style={{ marginLeft: '10px' }}>
                    {`${props.data.description}`}
                    <b></b>
                </span>
                {
                    props.justificationTypes && props.justificationTypes?.length > 0 ? (<span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                        {`${props.justificationTypes?.find(i => i.justificationTypeId === props.data.justificationTypeId).description}`}
                    </span>) : null
                }
                <span className="second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-account" /> {getUserNameToName(props?.usersFromElog, props.data.updateBy)}
                </span>
                <span className="second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-history" /> {formatData(props.data?.updateOn)}
                </span>
            </Link>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justification: state.justificationReducer.justification,
        usersFromElog: state.usersElogReducer.usersElog

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        justificationDelete: (justification, callback) => {
            dispatch(JustificationService.DeleteJustification(justification.justificationId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(JustificationListItem)));
